module.exports = __webpack_public_path__ + "static/img/point_zd_3.30de3795.png";